import React from "react";
import { makeStyles, Grid, Button } from "@material-ui/core";
import useTranslation from "../../application/translation";

const useStyles = makeStyles((theme) => ({
    rightWrapper: {
        justifyContent: "flex-end",
        marginTop: "1rem",
    },
    leftWrapper: {
        justifyContent: "flex-start",
        marginTop: "1rem",
    },
    button: {
        marginRight: theme.spacing(1),
    },
    root: {
        backgroundColor: "#fff",
    },
}));

const WizardButtons = ({ leftButton, handleBack, isStepValid, nextButtonLabel }) => {
    const classes = useStyles();
    const translation = useTranslation();

    return (
        <Grid container item role="group" aria-label={translation.stepper_controls}>
            <Grid item container className={classes.leftWrapper} xs={6}>
                {leftButton}
            </Grid>
            <Grid item container className={classes.rightWrapper} xs={6}>
                <Button
                    type="button"
                    onClick={handleBack}
                    className={classes.button}
                    aria-label={translation.stepper_back}
                >
                    {translation.stepper_back}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    type="submit"
                    disabled={!isStepValid}
                    aria-label={nextButtonLabel || translation.stepper_next}
                    aria-disabled={!isStepValid}
                >
                    {nextButtonLabel || translation.stepper_next}
                </Button>
            </Grid>
        </Grid>
    );
};

export default WizardButtons;
